import { Reveal } from './Reveal';
import { QuoteCalculator } from '../components/QuoteCalculator';

const NEEDS = [
  'Certaines entreprises cherchent simplement à réduire la paperasse.',
  "D'autres veulent éliminer la double saisie.",
  "D'autres veulent mieux coordonner leurs opérations.",
  'Certaines veulent seulement récupérer quelques heures par semaine.',
  "D'autres veulent transformer complètement leur façon de travailler.",
];
const PAINS = ['Trop de papier ?', "Trop d'appels ?", 'Trop de recherches ?', 'Trop de doubles saisies ?'];

export const BuildSolution = () => (
  <section className="bg-[#0B0F19] py-28 md:py-40" id="construire" data-testid="build-solution-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-10">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 mb-24">
        <Reveal className="lg:col-span-6">
          <p className="text-xs uppercase tracking-[0.3em] text-amber-500 font-semibold mb-4">À votre mesure</p>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl uppercase font-bold tracking-tight text-white leading-[0.95]" data-testid="build-solution-title">
            Chaque entreprise mérite une solution adaptée à sa réalité.
          </h2>
          <p className="text-2xl text-amber-400 font-medium mt-8">Vous n'avez pas besoin de tout.</p>
        </Reveal>
        <div className="lg:col-span-6 space-y-4 lg:pt-10">
          {NEEDS.map((n, i) => <Reveal key={i} delay={i * 100} className="text-lg text-slate-300">{n}</Reveal>)}
          <Reveal delay={550} className="text-lg text-white font-medium pt-4">
            Choisissez uniquement les outils qui vous aideront à retrouver du temps pour ce qui compte réellement.
          </Reveal>
        </div>
      </div>

      <Reveal className="border-y border-white/10 py-14 mb-20" data-testid="build-solution-transition">
        <p className="text-slate-400 text-lg mb-6">Commencez par le problème qui vous ralentit le plus.</p>
        <div className="flex flex-wrap gap-x-10 gap-y-3 mb-8">
          {PAINS.map(p => <span key={p} className="font-heading text-3xl sm:text-4xl uppercase font-bold tracking-tight text-white/90">{p}</span>)}
        </div>
        <p className="text-slate-300 text-lg">Sélectionnez uniquement les outils dont vous avez besoin aujourd'hui.</p>
        <p className="text-amber-400 text-lg font-medium mt-1">ProPilote grandit avec votre entreprise.</p>
      </Reveal>

      <Reveal>
        <h3 className="font-heading text-4xl sm:text-5xl uppercase font-bold tracking-tight text-white mb-10" data-testid="configurator-title">Construisez votre solution.</h3>
      </Reveal>
      <QuoteCalculator story />
    </div>
  </section>
);
